import Link from 'next/link';
import { ROUTES } from '@/routes';
import { useIsWelfare } from '@/app/_hooks/useIsWelfare';
import Image from 'next/image';
import { DAVINCI_CDN } from '@/costants/defaultValues';

const logoAltText = 'Elty logo';
const logoFull = `${DAVINCI_CDN}/elty/elty-logo.svg`;
const logoShort = `${DAVINCI_CDN}/elty/elty-logo-mobile.svg`;

const LogoWrapper: React.FC<{ withoutLink: boolean; children: React.ReactNode }> = ({ withoutLink, children }) => {
  if (withoutLink) {
    return <>{children}</>;
  }
  return (
    <Link href={ROUTES.HOME.pathname} prefetch={false} legacyBehavior>
      <a href={ROUTES.HOME.pathname} className="w-auto">
        {children}
      </a>
    </Link>
  );
};

export const HeaderLogo: React.FC<{ type: 'full' | 'short'; isApp?: boolean }> = ({ isApp = false, type = 'short' }) => {
  const isWelfare = useIsWelfare();
  const src = type === 'full' ? logoFull : logoShort;

  return (
    <LogoWrapper withoutLink={isWelfare || isApp}>
      <div className={`${type === 'full' ? 'h-[56px] w-[128px]' : 'h-[32px] w-[42px]'} relative`}>
        <Image src={src} alt={logoAltText} fill />
      </div>
    </LogoWrapper>
  );
};
